import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import { useAuth } from "context/auth.context";

function ChatbotRegister({ setToken, onShowLogin }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [registerLoading, setRegisterLoading] = useState(false);
  const { user } = useAuth();

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegisterLoading(true);
    setError("");
    try {
      const res = await fetch("/api/chatbots", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, user_id: user?.id }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || "Chyba pri vytváraní chatbota");
        setRegisterLoading(false);
        return;
      }
      // Po získaní tokenu načítaj info o chatbote
      try {
        const infoRes = await fetch("https://rieshim.app/v1/chatbot/me", {
          headers: { Authorization: `Bearer ${data.token}` },
        });
        if (!infoRes.ok) throw new Error("Chyba pri načítaní info o chatbote");
        const infoData = await infoRes.json();
        console.log("CHATBOT INFO po registrácii:", infoData);
      } catch (infoErr) {
        // Nepovinné: môžeš zobraziť chybu alebo logovať
        console.error("Nepodarilo sa načítať info o chatbote po registrácii");
      }
      setToken(data.token);
      setError("");
      setRegisterLoading(false);
    } catch (err) {
      setError("Chyba siete alebo servera", err);
      setRegisterLoading(false);
    }
  };

  return (
    <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
      <Card sx={{ minWidth: 400 }}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            Vytvorenie Chatbota
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3} component="form" onSubmit={handleRegister}>
          <MDBox mb={2}>
            <MDInput
              type="text"
              label="Meno chatbota"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              disabled={registerLoading}
              autoFocus
            />
          </MDBox>
          {error && (
            <MDBox mb={2}>
              <MDTypography color="error" variant="button">
                {error}
              </MDTypography>
            </MDBox>
          )}
          <MDBox mt={4} mb={1}>
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              type="submit"
              disabled={registerLoading || !name.trim()}
            >
              {registerLoading ? "Vytváram..." : "Vytvoriť chatbota"}
            </MDButton>
          </MDBox>
          <MDBox mt={1} mb={1}>
            <MDButton
              variant="outlined"
              color="info"
              fullWidth
              type="button"
              onClick={onShowLogin}
              disabled={registerLoading}
            >
              Späť na prihlásenie
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
}

ChatbotRegister.propTypes = {
  setToken: PropTypes.func.isRequired,
  onShowLogin: PropTypes.func.isRequired,
};

export default ChatbotRegister;
